<template>
    <div class="page">
        <div class="content-item">
            <div class="content-id">{{data.id}}</div>
            <!-- <div class="content-img" v-if="data.images">
                <img :src="data.images" />
            </div> -->
            <div class="content-info" v-html="data.content"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Contentdetail',
    data(){
        return {
            
        }
    },
    computed: {
        ...mapState(['lang']),
        data(){
            return this.$route.params.data
        },
    },
    created(){

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  background: #fff;
  padding: 1em 2em;
}
.content-item {
  padding: 1em 0;
  border-bottom: 1px #e8e8e8 dashed;
  .content-id {
    font-weight: bold;
    font-size: 1.8em;
    text-align: center;
  }
  .content-img {
    margin-top: .6em;
    text-align: center;
    img {
      max-width: rem(600);
      max-height: rem(303);
    }
  }
  .content-info {
    margin-top: .6em;
    & /deep/ img{
      max-width: rem(600);
      max-height: rem(303);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contentdetail.vue